import { render, staticRenderFns } from "./VIPpower.vue?vue&type=template&id=9b79c6ec&scoped=true"
import script from "./VIPpower.vue?vue&type=script&lang=js"
export * from "./VIPpower.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b79c6ec",
  null
  
)

export default component.exports